import React from "react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components";

import { TCampaignUploadSummary } from "../../campaign-upload.types";

interface ICampaignUploadSummaryCardsProps {
  summary: TCampaignUploadSummary;
  labels: {
    valid: string;
    invalid: string;
    duplicate: string;
    inserted: string;
  };
}

export const CampaignUploadSummaryCards: React.FC<
  ICampaignUploadSummaryCardsProps
> = ({ summary, labels }) => {
  const items = [
    { label: labels.valid, value: summary.validCount },
    { label: labels.invalid, value: summary.invalidCount },
    { label: labels.duplicate, value: summary.duplicateCount },
    { label: labels.inserted, value: summary.insertedCount },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {items.map((item) => (
        <Card key={item.label}>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              {item.label}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-2xl font-bold">{item.value}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
